/*
# Frontend JS | Vendor: FairVerify | App: Phoenix | Type: VisitorLeadApi
# FairVerify Event Solutions (fairverify.de) based on GodMode Core - GodMode.Systems
# Copyright Tim Haymann, FairVerify Event Solutions GmbH.
# created 2026-03-13 by Codex
# last edited 2026-03-16 by Codex // move api_user and live/dev domains into env
*/
const VISITOR_LEAD_API_PATH = '/api/lead/visitor/V1/scan.php'
const DEFAULT_VISITOR_LEAD_API_HOST_DEV = 'https://dev8.fairverify.com'
const DEFAULT_VISITOR_LEAD_API_HOST_LIVE = 'https://csmg.fairverify.com'
const DEFAULT_VISITOR_LEAD_API_USER = 'spring_cms'

function isZukunftPersonalHost() {
  const hostname = String(window.location.hostname || '').toLowerCase()
  return hostname === 'zukunft-personal.com' || hostname.endsWith('.zukunft-personal.com')
}

function resolveVisitorLeadApiToken() {
  return String(process.env.VUE_APP_VISITOR_LEAD_API_TOKEN || '').trim()
}

function resolveVisitorLeadApiDevUrl() {
  return String(process.env.VUE_APP_VISITOR_LEAD_API_URL_DEV || '').trim()
}

function resolveVisitorLeadApiLiveUrl() {
  return String(process.env.VUE_APP_VISITOR_LEAD_API_URL_LIVE || '').trim()
}

function resolveVisitorLeadApiUrl() {
  if (process.env.VUE_APP_VISITOR_LEAD_API_URL) {
    return process.env.VUE_APP_VISITOR_LEAD_API_URL
  }

  const configuredLiveUrl = resolveVisitorLeadApiLiveUrl()
  const configuredDevUrl = resolveVisitorLeadApiDevUrl()

  if (isZukunftPersonalHost()) {
    return configuredLiveUrl || `${DEFAULT_VISITOR_LEAD_API_HOST_LIVE}${VISITOR_LEAD_API_PATH}`
  }

  return configuredDevUrl || `${DEFAULT_VISITOR_LEAD_API_HOST_DEV}${VISITOR_LEAD_API_PATH}`
}

function resolveVisitorLeadApiUser() {
  return String(process.env.VUE_APP_VISITOR_LEAD_API_USER || DEFAULT_VISITOR_LEAD_API_USER).trim()
}

export async function syncVisitorLead(scanApi, scan) {
  const visitorLeadApiUrl = resolveVisitorLeadApiUrl()
  const visitorLeadApiUser = resolveVisitorLeadApiUser()
  const visitorLeadApiToken = resolveVisitorLeadApiToken()
  if (!visitorLeadApiToken) {
    console.warn('[visitor-lead] VUE_APP_VISITOR_LEAD_API_TOKEN is not set - request will be unauthenticated')
  }
  const requestConfig = visitorLeadApiToken
    ? { headers: { Authorization: `Bearer ${visitorLeadApiToken}` } }
    : undefined

  // A full URL keeps this proof-of-concept independent from the host scan API.
  const response = await scanApi.post(visitorLeadApiUrl, {
      api_user: visitorLeadApiUser,
      client_scan_id: scan.id,
      scanned_barcode: scan.code,
      user_ticket_barcode: scan.userTicketBarcode || '',
      user_ticket_secret: scan.userTicketSecret || '',
      fair_id: scan.fairId || '',
      user_uuid: scan.userUuid || '',
      scanned_at: scan.scannedAt
  }, requestConfig)
  const data = response.data || {}
  if (!data.success) {
    const error = new Error(data.message || 'Synchronization failed.')
    error.code = data.error_code || ''
    throw error
  }

  return data
}
